import app from 'actions/app';

const { mobileDetect } = window;

export const Theme = {
  layout0: {
    gutter: '20px',
    vgutter: '30px',
    padding: '40px',
  },
  fontFamily: {
    primary: 'soleil',
    primaryBold: 'Soleil-Bold',
  },
  fontWeight: {
    regular: '400',
    bold: '700',
    semiBold: '600',
  },
  desktop: {
    leftNavWidth: 220,
  },
  mobile: {
    phoneMaxWidth: mobileDetect && mobileDetect.mobile() ? 100000 : 768,
    phoneWidth: 768,
    mobileBreakpointWidth: 700,
    tinyMobileBreakpointWidth: 360,
    deviceHeight: app.docHeight(),
    isTablet: mobileDetect && mobileDetect.tablet(),
    isPhone: mobileDetect && mobileDetect.phone(),
    isMobile: mobileDetect && mobileDetect.mobile(),
  },
  forms: {
    dimensions: {
      inputHeight: 44,
      radioCircle: 28,
    },
    margins: {
      labelBottom: 10,
      capLabelBottom: 20,
      sectionBottom: 30,
    },
    buttons: {
      radius: 4,
    },
  },
  colors: {
    black: '#1F2532',
    white: '#FFF',
    lightBlue: '#e6f4f7',
    selectionBlue: '#ebf5ff',
    green: '#3D57FF',
    blue: '#3D57FF',
    gold: '#A08E5C',
    purple: '#2D1D81',
    lightGrayStar: '#AAAFB7',
    orange: '#fb8e3b',
    red: '#F2434F',
    darkRed: '#c40812',
    lightLine: '#DCDFE5',
    line: '#898C9A',
    divider: '#eee',
    lightBackground: '#F2F4F9',
    mediumBackground: '#CCCFD6',
    infoBackground: '#f5f5f5',
    darkBackground: '#505050',
    lightText: '#6A6E7C',
    lightestText: '#c8c8c8',
    mediumText: '#666',
    darkText: '#505050',
    hoverText: '#888',
    lightBorder: '#cccccc',
    gray: '#6e6e6e',

    /* Dashboard Redisgn Updated Colors */

    // Direct colors variables
    linksDesignElementsBaseColor: '#3D57FF',
    primaryTextColor: '#1F2532',
    secondaryTextColor: '#6A6E7C',
    guideTextColor: '#6A6E7C',
    iconsNotLinkedColor: '#898C9A',
    iconsLinkedColor: '#3D57FF',
    iconsBookingCalendarColor: '#1F2532',
    borderActionableFieldColor: '#888CA5',
    dividerInactionableFieldColor: '#DCDFE5',
    backgroundColor: '#F2F4F9',
    errorRedColor: '#D82F2E',
    errorRedColorDark: '#D82F2F',
    activeHoverStateColor: '#EBF5FF',
    warningColor: '#F39516',
    overlayColor: '#1F2532',
    statusColor: '#1F2532',
    sidebarNavHoverColor: '#3A4152',
    primaryCalendarColor: '#5DB322',
    primaryCalendarBackgroundColor: '#DFF0D3',
    blockedBookingsColor: '#DCDFE5',
    pendingBookingsColor: '#FB8E3B',
    pendingBookingsBackgroundColor: '#FDD2B1',
    experiencesWithNoguestColor: '#54C7EF',
    menuIconColor: '#CCCFD6',
    anygradient: 'linear-gradient(to bottom,  #2DC5B8 ,  #3D57FF ) 1 100%',
    leftToRightGradient: 'linear-gradient(to right, #2DC5B8, #3D57FF) 1',
    toastColor: '#2dc5b8',
    previewIconColor: '#8C8C8C',
    previewSubtleOutlineColor: '#949494',
    previewSecondaryTextColor: '#6E6E6E',
    previewGuideTextColor: '#757575',
    // Actions colors variable
    buttonHoverColor: '#263DD6',

    /* Dashboard Redisgn Updated Colors */
    inputs: {
      border: '#888CA5',
      placeholder: '#6A6E7C',
      disabled: {
        color: '#6A6E7C',
        backgroundColor: '#F2F4F9',
      },
    },
  },
  // features
  msg: {
    sidebarWidth: 360,
    filterHeight: 60,
  },
  insights: {
    salesColor: '#1f94c1',
    customersColor: '#6565b7',
    brandsColor: '#F2434F',
    salesColors: [
      '#0a568e',
      '#1f94c1',
      '#5ebfe1',
      '#98d5e5',
      '#C5E9EF',
      '#003060',
    ],
    customersColors: [
      '#4b4589',
      '#6565b7',
      '#8b8bcc',
      '#b5b5e5',
      '#D7D7F7',
      '#2D2768',
    ],
    arrows: {
      green: '#22b573',
      red: '#ed1c24',
    },
    nps: {
      green: '#01CBA6',
      yellow: '#f9b73e',
      red: '#ef6e64',
    },
    nlp: {
      green: '#01CBA6',
      red: '#ED1C24',
    },
    tooltipColor: '#bbb',
  },
  // next feature goes here...
};

export function statusColor(status) {
  let color = Theme.colors.lightText;
  if (status === 'confirmed') {
    color = Theme.colors.linksDesignElementsBaseColor;
  } else if (status === 'taken') {
    color = Theme.colors.linksDesignElementsBaseColor;
  } else if (status === 'finished') {
    color = Theme.colors.linksDesignElementsBaseColor;
  } else if (status === 'pending') {
    color = Theme.colors.orange;
  } else if (status === 'cancelled') {
    color = Theme.colors.red;
  }
  return color;
}
